<template>
    <div  :style="{'height':clientHeight-90+'px'}">
        <vue-scroll :ops="$ops">
            <div >
                <div class="m-portlet m-b-10">
                    <div class="m-portlet__body">
                        <el-form label-width="100px">
                            <el-row :gutter="20">
                                <el-col :span="6">
                                    <el-form-item label="类型">
                                        <el-select v-model="type"  placeholder="请选择学期" filterable remote
                                                   @change="handleChange()">
                                            <el-option
                                                    v-for="item in types"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="选择学期">
                                        <el-select v-model="semesterType_id"  placeholder="请选择学期" filterable remote
                                                   @change="changeSemesterType()">
                                            <el-option
                                                    v-for="item in semesterTypes"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="选择对比学期">
                                        <el-select v-model="contrastSemesterType_ids"
                                                   clearable
                                                   placeholder="请选择对比学期"
                                                   multiple
                                                   remote
                                                   @change="handleChange()">
                                            <el-option
                                                    v-for="item in nextSemesterTypes"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="">
                                        <el-switch v-model="showDecimal"
                                                   active-text="小数"
                                                   size="small">
                                        </el-switch>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </div>
                <div class="m-portlet m-b-0">
                    <div class="m-portlet__body" v-loading="loading">
                        <el-table
                                :data="continueToClassRenewals"
                                style="width: 100%"
                                size="middle">
                            <el-table-column prop="name" label="类型" align="center"></el-table-column>
                            <el-table-column prop="all_rate" label="整体" align="right" v-if="!showDecimal"></el-table-column>
                            <el-table-column prop="all_rate_decimal" label="整体" align="right" v-else></el-table-column>

                            <el-table-column prop="rate1" label="预初" align="right" v-if="!showDecimal"></el-table-column>
                            <el-table-column prop="rate_decimal1" label="预初" align="right" v-else></el-table-column>

                            <el-table-column prop="rate2" label="初一" align="right" v-if="!showDecimal"></el-table-column>
                            <el-table-column prop="rate_decimal2" label="初一" align="right" v-else></el-table-column>

                            <el-table-column prop="rate3" label="初二" align="right" v-if="!showDecimal"></el-table-column>
                            <el-table-column prop="rate_decimal3" label="初二" align="right" v-else></el-table-column>

                            <el-table-column prop="rate4" label="初三" align="right" v-if="!showDecimal"></el-table-column>
                            <el-table-column prop="rate_decimal4" label="初三" align="right" v-else></el-table-column>

                            <el-table-column prop="rate5" label="高一" align="right" v-if="!showDecimal"></el-table-column>
                            <el-table-column prop="rate_decimal5" label="高一" align="right" v-else></el-table-column>

                            <el-table-column prop="rate6" label="高二" align="right" v-if="!showDecimal"></el-table-column>
                            <el-table-column prop="rate_decimal6" label="高二" align="right" v-else></el-table-column>

                            <el-table-column prop="rate7" label="高三" align="right" v-if="!showDecimal"></el-table-column>
                            <el-table-column prop="rate_decimal7" label="高三" align="right" v-else></el-table-column>
                        </el-table>
                        <!--分页-->
                        <div class="text-center m-t-10">
                            <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="10"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </vue-scroll>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                path:"/renewalContinueClass/list",
                semesterTypes:[],
                semesterType_id:'',
                contrastSemesterType_ids:[],
                loading: true,
                showDecimal:false,
                nextSemesterTypes:[],
                type:'subject',
                types:[
                    {
                        id:'subject',
                        name:'学科'
                    },
                    {
                        id:'teacher',
                        name:'老师'
                    }
                ],
                continueToClassRenewals:[],
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
            };
        },
        mounted() {
            this.$nextTick(() => {
            })
        },
        created() {
            this.semester_id=this.$store.state.config.nowSemester.id;
            this.handleIndex();
            this.handleShow();
            this.handleCreate();

        },
        computed: {
            right_level() {
                return this.$store.state.user.employee.right_level;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate(){
                //建立webSocket链接
                this.$wApi.addListen(this.path,this.handleData);
            },
            handleShow() {
                this.$wApi.send(this.path,'init',{});
            },
            handleData(event,data){
                switch (event) {
                    case 'init':
                        this.semesterTypes =data.semesterTypes;
                        this.semester=3;
                        break;
                    case 'list':
                        this.total = data.total;
                        this.continueToClassRenewals = data.continueToClassRenewals;
                        this.nextSemesterTypes=data.nextSemesterTypes
                        this.semesterType_id=data.semesterType_id
                        this.loading = false;
                        break;
                }
            },
            changeSemesterType(){
                this.loading = true;
                this.contrastSemesterType_ids=[];
                this.handleIndex();
            },
            handleChange(){
                this.loading = true;
                this.handleIndex();
            },
            handleIndex(currentPage = 1) {
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': this.currentPage,
                    'currentPageSize': this.currentPageSize,
                    'semesterType_id': this.semesterType_id,
                    'type': this.type,
                    'contrastSemesterType_ids': this.contrastSemesterType_ids,
                    'nowSemester_id': this.$store.state.config.nowSemester.id,
                });
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },
        }
    }
</script>


<style scoped>

</style>
